var _defs, _rect, _rect2, _rect3, _path, _circle, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#C8A55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C7E3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldSoft3",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C8A55B",
    stopOpacity: 0.04
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 128,
    width: 12,
    height: 28,
    rx: 2,
    fill: "url(#gold3)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 152,
    width: 28,
    height: 6,
    rx: 3,
    fill: "url(#gold3)",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 100,
    width: 20,
    height: 32,
    rx: 4,
    fill: "url(#goldSoft3)",
    stroke: "url(#gold3)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 100 L100 82 L112 100 Z",
    fill: "url(#goldSoft3)",
    stroke: "url(#gold3)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 88,
    r: 3,
    fill: "url(#gold3)",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112 A16 16 0 0 1 116 112",
    stroke: "url(#gold3)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 118 A28 28 0 0 1 128 118",
    stroke: "url(#gold3)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none",
    strokeOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 124 A40 40 0 0 1 140 124",
    stroke: "url(#gold3)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none",
    strokeOpacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 130 A52 52 0 0 1 152 130",
    stroke: "url(#gold3)",
    strokeWidth: 1,
    strokeLinecap: "round",
    fill: "none",
    strokeOpacity: 0.25,
    strokeDasharray: "4 3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 96,
    r: 2.5,
    fill: "url(#gold3)",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 96,
    r: 2.5,
    fill: "url(#gold3)",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 80,
    r: 1.5,
    fill: "url(#gold3)",
    fillOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 80,
    r: 1.5,
    fill: "url(#gold3)",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCampaigns);
export default __webpack_public_path__ + "static/media/empty-campaigns.c3017da376a2f9ac324281b02a6a3112.svg";
export { ForwardRef as ReactComponent };